import { jsx as _jsx } from "react/jsx-runtime";
import { DISABLED_ICON_COLOR } from './contants';
import { IconButton } from '@appspotr/ui-kit';
import { faChevronLeft, faChevronRight, } from '@fortawesome/pro-regular-svg-icons';
export var NavigationButton = function (_a) {
    var onNavigate = _a.onNavigate, next = _a.next, disabled = _a.disabled;
    return (_jsx(IconButton, { icon: next ? faChevronRight : faChevronLeft, iconStyle: {
            color: disabled ? DISABLED_ICON_COLOR : undefined,
        }, onClick: function () { return onNavigate(); }, type: "neutral", disabled: disabled }));
};
